import { SelectField } from '@resurs-internal/mui';
import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { addOrUpdateFormField } from '../../store/applicationform';
import { selectFieldValue } from '../../store/applicationform/applicationFormSelectors';
import { IFieldState } from '../../store/applicationform/applicationFormTypes';
import ValidationError from '../ValidationError/ValidationError';

export const hideNativeSelectArrowSx = {
    '& span': {
        display: 'none',
    },
};

type SelectProps = {
    name: string;
    label?: string;
    value?: string;
    options?: SelectFieldOption[];
    children?: SelectFieldOption[];
};

const Select = (props: SelectProps) => {
    const dispatch = useAppDispatch();
    const value = useAppSelector(selectFieldValue)(props.name);
    const selectFieldOptions = props.options ? props.options : props.children ? props.children : [];

    function handleChange(value: string | unknown) {
        const option = selectFieldOptions.find((field) => field.id === value);

        dispatch(
            addOrUpdateFormField({
                fieldName: props.name,
                value,
                label: option?.label,
                hasError: false,
            } as IFieldState),
        );
    }

    return (
        <>
            <SelectField
                sx={hideNativeSelectArrowSx}
                value={value ? value.toString() : ''}
                label={props.label}
                outline={'single'}
                name={props.name}
                onChange={(e: { target: { value: unknown } }) => handleChange(e.target.value)}
                options={selectFieldOptions}
                aria-label={props.label}
            />
            <ValidationError fieldName={props.name} />
        </>
    );
};
export default Select;
